// extracted by mini-css-extract-plugin
export default {"menu":"index_menu__4rdXu","menu-item":"index_menu-item__MqzwE","menu-item-icon":"index_menu-item-icon__HpaH4","menu-item-text":"index_menu-item-text__gRi8z"};